<template>
    <div>
        <b-form-group :label="customLabel" label-for="level_4_id">
            <v-select
                v-model="level4id"
                class="pt-0" label="name" name="name"
                :reduce="(option) => option.id"
                :options="levels4List"
                :disabled="disabled"
            />
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue'
import vSelect from "vue-select"

export default {
    components: {
        BFormGroup,
        vSelect,
    },
    props: {
        //eslint-disable-next-line vue/prop-name-casing
        level4id: {
            type: Number,
            default: null
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        customLabel: {
            type: String,
            default: "Nível 4"
        }
    },
    data() {
        return {
            levels4List: [],
            localLevel4Id: this.level4id,
        }
    },
    watch: {
        level4id(newVal) {
            this.localLevel4Id = newVal
            this.$emit('update', { level_4_id: this.localLevel4Id })
        },
    },
    mounted() {
        this.getLevels4()
    },
    methods:{
        getLevels4() {
            this.showLoading = true

            this.$store.dispatch('level4Vhe/getAllLevels4')
            .then(response => {
                this.levels4List = response

                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
    },
}
</script>
